import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import store from "./app/store";
import { Provider } from "react-redux";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const container = document.getElementById('root');

if (container){
	const root = createRoot(container)
	root.render(
		<Provider store={store}>
			<App />
		</Provider>
	)
} else {
	throw new Error(
		"Root element with ID 'root' was not found in the document. Ensure there is a corresponding HTML element with the ID 'root' in your HTML file.",
	)
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
